/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/no-unknown-property */
/* eslint-disable import/no-cycle */
/*
 * Some useful utility functions
 */
import {ulid} from 'ulid';
import Locale from './Locale';
import dragicon from '../images/dragIcon.png';
import Analytics from './Analytics';

// const dragimage = new Image();
const dragimage = document.createElement('img');
dragimage.src = dragicon;

let isWidgetMode = null; // Optimized to read url parameters once
let uploaderLibraryId = null;
let isMaintenanceMode = null;

export default class Util {
    static ROOT_DIR = '_root_';

    static ROOT_PATH = 'medialibrary-services/client/media';

    static WRITE_ROOT_PATH = 'medialibrary-services/client/write';

    static COMPOSER_SELECTED_ASSET_URL_EVENT_TYPE = 'asset-select';

    static TESTING_MODE = false; // Force delay to 0 ms when true for testing

    static FILE_TYPE = {
        IMAGE: 'IMG',
        PDF: 'PDF',
        DOCUMENT: 'DOCUMENT',
        VIDEO: 'VIDEO',
        VIDEOPROCESSING: 'VIDEOPROCESSING'
    };

    static MEDIA_TYPE = {
        ASSET: 'asset',
        FOLDER: 'folder'
    };

    static ASSET_FILTER_TYPE = {
        IMAGES: 'images',
        VIDEOS: 'videos',
        DOCUMENTS: 'documents'
    };

    static IMG_SORT_TYPE = {
        ALL: 'images:all',
        RATIO_4_1: '4:1',
        RATIO_4_3: '4:3',
        RATIO_10_1: '10:1',
        RATIO_9_16: '9:16'
    };

    static SOURCE_TYPE = {
        WEB: 'web',
        ADV: 'adv'
    };

    static TAB_TYPE = {
        FOLDER: 0,
        TAGS: 1
    };

    static MIN_LOGOUTCHECK_ELAPSE = 10 * 1000; // This is just to stop a cluster of bad fetches

    static lastLogoutCheck = localStorage.getItem('DPlastLogoutCheck') / 1 || 0;

    static getDragIcon() {
        return dragimage;
    }

    static getBoolean(value) {
        switch (value) {
            case true:
            case 'true':
            case 1:
            case '1':
            case 'on':
            case 'yes':
                return true;
            default:
                return false;
        }
    }

    static addEventListener(eventType, callback) {
        if (document.addEventListener) {
            window.addEventListener(eventType, callback);
        } else {
            window.attachEvent(eventType, callback); // IE11
        }
    }

    static removeEventListener(eventType, callback) {
        if (document.removeEventListener) {
            window.removeEventListener(eventType, callback);
        } else {
            window.detachEvent(eventType, callback); // IE11
        }
    }

    // Should pass a payload.detail object for custom event details
    //
    static dispatchEvent(eventType, payload_) {
        let event;
        if (typeof window.CustomEvent !== 'function') {
            const payload = payload_ || {};
            const params = {bubbles: false, cancelable: false, detail: undefined, ...payload};
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventType, params.bubbles, params.cancelable, params.detail);
        } else {
            event = new CustomEvent(eventType, payload_);
        }
        window.dispatchEvent(event);
    }

    static capitalize(str) {
        if (typeof str === 'string') {
            return str.charAt(0).toUpperCase() + str.substr(1);
        }
        return str;
    }

    static getFileTypeLabelFromMimeType(mimeType_, data, pdfIsDocument = false) {
        if (mimeType_) {
            const mimeType = mimeType_.slice(0).toLowerCase();
            if (mimeType.indexOf('image') !== -1) {
                return Util.FILE_TYPE.IMAGE;
            }
            if (mimeType.indexOf('video') !== -1 || mimeType.indexOf('flash') !== -1) {
                return data && 'status' in data && data.status ? Util.FILE_TYPE.VIDEOPROCESSING : Util.FILE_TYPE.VIDEO;
            }
            if (mimeType.indexOf('pdf') !== -1) {
                return pdfIsDocument ? Util.FILE_TYPE.DOCUMENT : Util.FILE_TYPE.PDF;
            }
        }
        if (data && 'name' in data && data.name) {
            if (Util.isImageFile(data.name)) {
                return Util.FILE_TYPE.IMAGE;
            }
            if (Util.isVideoFile(data.name)) {
                return Util.FILE_TYPE.VIDEO;
            }
        }
        return Util.FILE_TYPE.DOCUMENT;
    }

    // Remove query string from a given url (or any) string
    static removeQueryString(url) {
        const questionIdx = url?.lastIndexOf('?');
        return questionIdx > -1 ? url?.substring(0, questionIdx) : url;
    }

    static isImageFile(filename_) {
        if (!filename_) {
            return false;
        }
        const filename = filename_.slice().toLowerCase();
        const periodIdx = filename.lastIndexOf('.');
        if (periodIdx === -1) {
            return false;
        }
        const ext = filename.substring(periodIdx + 1, filename.length) || filename;
        return ['jpg', 'jpeg', 'heic', 'jfif', 'png', 'gif', 'bmp', 'webp'].indexOf(Util.removeQueryString(ext)) > -1;
    }

    static isVideoFile(filename_) {
        if (!filename_) {
            return false;
        }
        const filename = filename_.slice().toLowerCase();
        const periodIdx = filename.lastIndexOf('.');
        if (periodIdx === -1) {
            return false;
        }
        const ext = filename.substring(periodIdx + 1, filename.length) || filename;
        return ['mp4', 'avi', 'wmv', 'mpeg2', 'mov', 'mpg', 'mpeg', 'xml'].indexOf(ext) > -1;
    }

    static byteSizeString(value, decimalPlaces) {
        if (typeof value === 'number') {
            let val = Math.abs(value);
            let multiplier = 0;
            while (val >= 1000 && multiplier < 3) {
                val *= 0.001;
                multiplier += 1;
            }
            if (decimalPlaces) {
                val = val.toFixed(decimalPlaces);
            } else {
                val = Math.round(val);
            }
            const extra = ['', 'kB', 'MB', 'GB'][multiplier];
            return `${val} ${extra}`;
        }
        return value;
    }

    static isMobile() {
        return window.innerWidth < 547;
    }

    static LOCAL_DEV_HOST_SUFFIXES = ['localhost', '.dealercenter-local.coxautoinc.com'];

    static isLocalDev() {
        const {hostname} = window.location;
        return Util.LOCAL_DEV_HOST_SUFFIXES.some(suffix => hostname?.includes(suffix));
    }

    static isSplitScreen() {
        return Util.isWidget() || window.innerWidth >= 935;
    }

    static getVideoAssetLink(url) {
        // DE558999 - Fix for video thumbnail adding .mp4
        if (url.includes('.mp4.xml')) {
            return `${url.replace('.mp4.xml', '_highest.mp4')}`;
        }
        return `${url.replace('.xml', '_highest.mp4')}`;
    }

    static getXIcon(color = 'white') {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                height="16"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 16 16"
                width="16"
            >
                <line x1="14" x2="6" y1="6" y2="14" />
                <line x1="6" x2="14" y1="6" y2="14" />
            </svg>
        );
    }

    static getProcessingIcon(color = 'white') {
        return (
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 22.7321L18.5 28.7942C17.1667 29.564 15.5 28.6018 15.5 27.0622L15.5 14.9378C15.5 13.3982 17.1667 12.436 18.5 13.2058L29 19.268C30.3333 20.0378 30.3333 21.9623 29 22.7321Z"
                    stroke={color}
                    stroke-width="2"
                />
                <circle
                    cx="21"
                    cy="21"
                    r="20"
                    stroke={color}
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-dasharray="3 7"
                />
                <path
                    d="M41 21C41 17.0444 39.827 13.1776 37.6294 9.88859C35.4318 6.59961 32.3082 4.03616 28.6537 2.52241C24.9991 1.00866 20.9778 0.61259 17.0982 1.38429C13.2186 2.156 9.65491 4.06081 6.85786 6.85786C4.06081 9.65491 2.156 13.2186 1.38429 17.0982C0.61259 20.9778 1.00866 24.9991 2.52241 28.6537C4.03616 32.3082 6.59961 35.4318 9.8886 37.6294C13.1776 39.827 17.0444 41 21 41"
                    stroke={color}
                    stroke-width="2"
                    stroke-linecap="round"
                />
            </svg>
        );
    }

    static getDeleteIcon(color = 'white') {
        return (
            <svg
                height="24"
                width="24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    fill="none"
                    stroke={color}
                    d="M20,9v12c0,1.1-0.9,2-2,2H6c-1.1,0-2-0.9-2-2V9"
                />
                <line
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    fill="none"
                    stroke={color}
                    x1="1"
                    y1="5"
                    x2="23"
                    y2="5"
                />
                <line
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    fill="none"
                    stroke={color}
                    x1="12"
                    y1="12"
                    x2="12"
                    y2="18"
                />
                <line
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    fill="none"
                    stroke={color}
                    x1="8"
                    y1="12"
                    x2="8"
                    y2="18"
                />
                <line
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    fill="none"
                    stroke={color}
                    x1="16"
                    y1="12"
                    x2="16"
                    y2="18"
                />
                <polyline
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    fill="none"
                    stroke={color}
                    points="8,5 8,1 16,1 16,5 "
                />
            </svg>
        );
    }

    static getCropIcon() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                height="24"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                width="24"
            >
                <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15" />
                <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15" />
            </svg>
        );
    }

    static getPlaceholderByType(fileType) {
        let placeholder;
        switch (fileType) {
            case Util.FILE_TYPE.IMAGE:
                placeholder =
                    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBzdHJva2U9IiMwMDQ4N0YiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xLjM2MzY1IDI4LjYzNjRMOC4yNzI3NCAyMS43MjczTDE3LjcyNzMgMzEuMTgxOEwzMS4xODE4IDE3LjcyNzNMNDAuMjcyNyAyNi44MTgyIiBzdHJva2U9IiMwMDQ4N0YiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxjaXJjbGUgY3g9IjE3LjM2MzYiIGN5PSIxMyIgcj0iNC43MjcyNyIgc3Ryb2tlPSIjMDA0ODdGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K';
                break;
            case Util.FILE_TYPE.VIDEO:
                placeholder =
                    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5IDIyLjczMjFMMTguNSAyOC43OTQyQzE3LjE2NjcgMjkuNTY0IDE1LjUgMjguNjAxOCAxNS41IDI3LjA2MjJMMTUuNSAxNC45Mzc4QzE1LjUgMTMuMzk4MiAxNy4xNjY3IDEyLjQzNiAxOC41IDEzLjIwNThMMjkgMTkuMjY4QzMwLjMzMzMgMjAuMDM3OCAzMC4zMzMzIDIxLjk2MjMgMjkgMjIuNzMyMVoiIHN0cm9rZT0iIzAwNDg3RiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcng9IjIiIHN0cm9rZT0iIzAwNDg3RiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHJlY3QgeD0iNSIgeT0iNCIgd2lkdGg9IjUiIGhlaWdodD0iMyIgcng9IjEuNSIgZmlsbD0iIzAwNDg3RiIvPgo8cmVjdCB4PSIxNCIgeT0iNCIgd2lkdGg9IjUiIGhlaWdodD0iMyIgcng9IjEuNSIgZmlsbD0iIzAwNDg3RiIvPgo8cmVjdCB4PSIzMiIgeT0iNCIgd2lkdGg9IjUiIGhlaWdodD0iMyIgcng9IjEuNSIgZmlsbD0iIzAwNDg3RiIvPgo8cmVjdCB4PSIyMyIgeT0iNCIgd2lkdGg9IjUiIGhlaWdodD0iMyIgcng9IjEuNSIgZmlsbD0iIzAwNDg3RiIvPgo8cmVjdCB4PSI1IiB5PSIzNSIgd2lkdGg9IjUiIGhlaWdodD0iMyIgcng9IjEuNSIgZmlsbD0iIzAwNDg3RiIvPgo8cmVjdCB4PSIxNCIgeT0iMzUiIHdpZHRoPSI1IiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIGZpbGw9IiMwMDQ4N0YiLz4KPHJlY3QgeD0iMzIiIHk9IjM1IiB3aWR0aD0iNSIgaGVpZ2h0PSIzIiByeD0iMS41IiBmaWxsPSIjMDA0ODdGIi8+CjxyZWN0IHg9IjIzIiB5PSIzNSIgd2lkdGg9IjUiIGhlaWdodD0iMyIgcng9IjEuNSIgZmlsbD0iIzAwNDg3RiIvPgo8L3N2Zz4K';
                break;
            case Util.FILE_TYPE.VIDEOPROCESSING:
                placeholder =
                    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5IDIyLjczMjFMMTguNSAyOC43OTQyQzE3LjE2NjcgMjkuNTY0IDE1LjUgMjguNjAxOCAxNS41IDI3LjA2MjJMMTUuNSAxNC45Mzc4QzE1LjUgMTMuMzk4MiAxNy4xNjY3IDEyLjQzNiAxOC41IDEzLjIwNThMMjkgMTkuMjY4QzMwLjMzMzMgMjAuMDM3OCAzMC4zMzMzIDIxLjk2MjMgMjkgMjIuNzMyMVoiIHN0cm9rZT0iIzAwNDg3RiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgY3g9IjIxIiBjeT0iMjEiIHI9IjIwIiBzdHJva2U9IiMwMDQ4N0YiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSIzIDciLz4KPHBhdGggZD0iTTQxIDIxQzQxIDE3LjA0NDQgMzkuODI3IDEzLjE3NzYgMzcuNjI5NCA5Ljg4ODU5QzM1LjQzMTggNi41OTk2MSAzMi4zMDgyIDQuMDM2MTYgMjguNjUzNyAyLjUyMjQxQzI0Ljk5OTEgMS4wMDg2NiAyMC45Nzc4IDAuNjEyNTkgMTcuMDk4MiAxLjM4NDI5QzEzLjIxODYgMi4xNTYgOS42NTQ5MSA0LjA2MDgxIDYuODU3ODYgNi44NTc4NkM0LjA2MDgxIDkuNjU0OTEgMi4xNTYgMTMuMjE4NiAxLjM4NDI5IDE3LjA5ODJDMC42MTI1OSAyMC45Nzc4IDEuMDA4NjYgMjQuOTk5MSAyLjUyMjQxIDI4LjY1MzdDNC4wMzYxNiAzMi4zMDgyIDYuNTk5NjEgMzUuNDMxOCA5Ljg4ODYgMzcuNjI5NEMxMy4xNzc2IDM5LjgyNyAxNy4wNDQ0IDQxIDIxIDQxIiBzdHJva2U9IiMwMDQ4N0YiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=';
                break;
            case Util.FILE_TYPE.PDF:
            case Util.FILE_TYPE.DOCUMENT:
            default:
                placeholder =
                    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCAzOSA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjM2LjU1MTciIGhlaWdodD0iNDAiIHN0cm9rZT0iIzAwNDg3RiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05Ljk2NTUyIDEyLjAzNDVIMjguOTMxIiBzdHJva2U9IiMwMDQ4N0YiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik05Ljk2NTUyIDIxSDI4LjkzMSIgc3Ryb2tlPSIjMDA0ODdGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS45NjU1MiAyOS45NjU1SDE4LjI0MTQiIHN0cm9rZT0iIzAwNDg3RiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==';
        }
        return placeholder;
    }

    static getPlaceholder(file) {
        const fileType = Util.getFileTypeLabelFromMimeType(file.mimeType, file);
        return this.getPlaceholderByType(fileType);
    }

    static getVideoThumbnail(file, onClick, draggable = false, handleError = null) {
        if (file.name) {
            return (
                <video onError={handleError} className="adv-video-thumbnail" height={108}>
                    <source src={file.name} />
                </video>
            );
        }
        return (
            <img
                src={this.getPlaceholderByType(Util.FILE_TYPE.VIDEO)}
                alt="Thumbnail"
                onClick={() => onClick && onClick(file)}
                draggable={draggable}
            />
        );
    }

    static getThumbnail(file, onClick, draggable = false) {
        const placeholder = this.getPlaceholder(file);

        // DE558999 - Fix for video thumbnail adding .mp4
        let {thumbName} = file;
        if (thumbName && (file?.mimeType?.includes('video') || thumbName.includes('.mp4_smallthumb'))) {
            thumbName = file.thumbName.replace('.mp4_smallthumb', '_smallthumb');
        }
        // Will show placeholder if thumbnail not found
        if (thumbName && !file.status && Util.isImageFile(thumbName)) {
            return (
                <img
                    src={thumbName}
                    alt="Thumbnail"
                    onError={e => {
                        e.target.onerror = null;
                        e.target.src = placeholder;
                        e.target.className = 'placeholder';
                    }}
                    draggable={draggable}
                />
            );
        }
        return <img className="placeholder" src={placeholder} alt="Thumbnail" draggable={draggable} />;
    }

    static getFileExtension(filename) {
        const eidx = filename.lastIndexOf('.');
        if (eidx !== -1) {
            return filename.substr(eidx + 1);
        }
        return '';
    }

    static formatSelectEvent(source) {
        const {id, name, height, width, label: title, altText} = source;
        return {
            key: Util.COMPOSER_SELECTED_ASSET_URL_EVENT_TYPE,
            value: {id, name, height, width, title, altText}
        };
    }

    static getInsertIcon() {
        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.6648 8.09495L14.6648 14.6648L8.09492 14.6648"
                    stroke="#00528A"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.6648 14.6648L7.6648 7.66479"
                    stroke="#00528A"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V12"
                    stroke="#00528A"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <circle cx="6" cy="6" r="2" stroke="#00528A" strokeWidth="2" />
            </svg>
        );
    }

    static getGridViewIcon(color = 'white') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" fill={color} stroke={color}>
                    <rect x="2" y="2" width="7" height="7" fill="none" stroke={color} strokeMiterlimit="10" />{' '}
                    <rect x="15" y="2" width="7" height="7" fill="none" strokeMiterlimit="10" />{' '}
                    <rect x="2" y="15" width="7" height="7" fill="none" strokeMiterlimit="10" />{' '}
                    <rect x="15" y="15" width="7" height="7" fill="none" stroke={color} strokeMiterlimit="10" />
                </g>
            </svg>
        );
    }

    static getListViewIcon(color = 'white') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" fill={color} stroke={color}>
                    <circle fill="none" strokeMiterlimit="10" cx="3" cy="4" r="2" />{' '}
                    <circle fill="none" strokeMiterlimit="10" cx="3" cy="12" r="2" />{' '}
                    <circle fill="none" strokeMiterlimit="10" cx="3" cy="20" r="2" />{' '}
                    <line fill="none" stroke={color} strokeMiterlimit="10" x1="9" y1="4" x2="23" y2="4" />{' '}
                    <line fill="none" stroke={color} strokeMiterlimit="10" x1="9" y1="12" x2="23" y2="12" />{' '}
                    <line fill="none" stroke={color} strokeMiterlimit="10" x1="9" y1="20" x2="23" y2="20" />
                </g>
            </svg>
        );
    }

    static getExtrasIcon(color = 'white') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                    fill={color}
                    d="M12 9.984q0.797 0 1.406 0.609t0.609 1.406-0.609 1.406-1.406 0.609-1.406-0.609-0.609-1.406 0.609-1.406 1.406-0.609zM18 9.984q0.797 0 1.406 0.609t0.609 1.406-0.609 1.406-1.406 0.609-1.406-0.609-0.609-1.406 0.609-1.406 1.406-0.609zM6 9.984q0.797 0 1.406 0.609t0.609 1.406-0.609 1.406-1.406 0.609-1.406-0.609-0.609-1.406 0.609-1.406 1.406-0.609z"
                />
            </svg>
        );
    }

    static getEditIcon(color = 'white') {
        return (
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <polygon
                    fill="none"
                    stroke={color}
                    points="16 3 21 8 8 21 3 21 3 16 16 3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
            </svg>
        );
    }

    static getClipboardCopyIcon(color = 'white') {
        return (
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <rect
                    fill="none"
                    height="13"
                    rx="2"
                    ry="2"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    width="13"
                    x="9"
                    y="9"
                />
                <path
                    d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                    fill="none"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
            </svg>
        );
    }

    static getOpenNewTabIcon(color = 'white') {
        return (
            <svg
                fill="none"
                height="24"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" x2="21" y1="14" y2="3" />
            </svg>
        );
    }

    static getUploadIcon(color = 'white') {
        return (
            <svg
                fill="none"
                height="24"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <polyline points="16 16 12 12 8 16" />
                <line x1="12" x2="12" y1="12" y2="21" />
                <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                <polyline points="16 16 12 12 8 16" />
            </svg>
        );
    }

    static getSearchIcon(color = 'white') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" fill={color} stroke={color}>
                    <line x1="22" y1="22" x2="15.656" y2="15.656" fill="none" strokeMiterlimit="10" />{' '}
                    <circle cx="10" cy="10" r="8" fill="none" stroke={color} strokeMiterlimit="10" />
                </g>
            </svg>
        );
    }

    static getAddIcon(color = '#00528A') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <g
                    className="nc-icon-wrapper"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    fill={color}
                    stroke={color}
                >
                    <line fill="none" stroke={color} strokeMiterlimit="10" x1="12" y1="2" x2="12" y2="22" />
                    <line fill="none" stroke={color} strokeMiterlimit="10" x1="22" y1="12" x2="2" y2="12" />
                </g>
            </svg>
        );
    }

    static getSortIcon(color = '#00528A') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                <path
                    fill={color}
                    stroke="transparent"
                    d="m 20.227277,15.136338 q 0,0.424733 -0.310375,0.735137 l -7.318179,7.318122 Q 12.288348,23.5 11.863633,23.5 11.43892,23.5 11.128554,23.189597 L 3.8103658,15.871475 Q 3.5,15.561071 3.5,15.136338 3.5,14.711604 3.8103658,14.401296 4.1207413,14.090892 4.5454554,14.090892 H 19.181822 q 0.424714,0 0.73508,0.310404 0.310375,0.310308 0.310375,0.735042 z m 0,-6.2726755 q 0,0.4247335 -0.310375,0.7350425 -0.310366,0.310402 -0.73508,0.310402 H 4.5454554 q -0.4247141,0 -0.7350896,-0.310402 Q 3.5,9.288396 3.5,8.8636625 3.5,8.4389282 3.8103658,8.128525 L 11.128554,0.8104042 Q 11.43892,0.5 11.863633,0.5 q 0.424715,0 0.73509,0.3104042 l 7.318179,7.3181208 q 0.310375,0.3104032 0.310375,0.7351375 z"
                />
            </svg>
        );
    }

    static getDateIcon(color = '#00528A') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                <g fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <line x1="3" y1="9" x2="21" y2="9" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                </g>
            </svg>
        );
    }

    static getLockIcon() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
                <g strokeWidth="1" fill="#000000" stroke="#000000">
                    <path
                        fill="none"
                        stroke="#000000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        d="M13.5,15.5h-11 c-0.552,0-1-0.448-1-1v-7c0-0.552,0.448-1,1-1h11c0.552,0,1,0.448,1,1v7C14.5,15.052,14.052,15.5,13.5,15.5z"
                    />{' '}
                    <path
                        fill="none"
                        stroke="#000000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        d="M4.5,6.5V4 c0-1.933,1.567-3.5,3.5-3.5h0c1.933,0,3.5,1.567,3.5,3.5v2.5"
                    />{' '}
                    <circle
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        cx="8"
                        cy="11"
                        r="1.5"
                    />{' '}
                </g>
            </svg>
        );
    }

    static getMoveIcon(color = '#00528A') {
        return (
            <svg
                fill="none"
                height="24"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <polyline points="5 9 2 12 5 15" />
                <polyline points="9 5 12 2 15 5" />
                <polyline points="15 19 12 22 9 19" />
                <polyline points="19 9 22 12 19 15" />
                <line x1="2" x2="22" y1="12" y2="12" />
                <line x1="12" x2="12" y1="2" y2="22" />
            </svg>
        );
    }

    static getResizeIcon(color = '#00528A') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color} width="24" height="24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z" />
            </svg>
        );
    }

    static sortByMap() {
        return {
            dateAsc: Locale.getText('SORT_DATE_ASC'),
            dateDes: Locale.getText('SORT_DATE_DES'),
            nameAsc: Locale.getText('SORT_NAME_ASC'),
            nameDes: Locale.getText('SORT_NAME_DES'),
            sizeAsc: Locale.getText('SORT_SIZE_ASC'),
            sizeDes: Locale.getText('SORT_SIZE_DES'),
            heightAsc: Locale.getText('SORT_HEIGHT_ASC'),
            heightDes: Locale.getText('SORT_HEIGHT_DES'),
            widthAsc: Locale.getText('SORT_WIDTH_ASC'),
            widthDes: Locale.getText('SORT_WIDTH_DES'),
            type: Locale.getText('SORT_TYPE')
        };
    }

    static async doesFileExist(fileUrl) {
        try {
            await fetch(fileUrl, {method: 'head', mode: 'no-cors'});
            return true;
        } catch (error) {
            return false;
        }
    }

    static getURLparameter(parameterKey, searchQuery_) {
        const searchQuery = searchQuery_ || window.location.search;
        const params = decodeURI(searchQuery).replace('?', '').split('&'); // No URLSearchParams on IE, so...
        const map = {};
        params.forEach(entry => {
            const split = entry.split('=');
            if (split.length === 2) {
                map[split[0].toLowerCase()] = split[1].trim();
            }
        });
        return map[parameterKey];
    }

    static getSingleURLparameter(parameterKey, searchQuery_) {
        const searchQuery = searchQuery_ || window.location.search;
        const params = new URLSearchParams(searchQuery);
        return params?.get(parameterKey);
    }

    static getBooleansFromUrlSearchParams(params = []) {
        return params.map(param => {
            const currentParam = Util.getURLparameter(param);
            return currentParam !== undefined ? Util.getBoolean(currentParam) : currentParam;
        });
    }

    static isWidget(searchQ) {
        const searchQuery = searchQ || window.location.search;
        if (isWidgetMode === null || searchQuery) {
            isWidgetMode = Util.getBoolean(Util.getURLparameter('widget', searchQuery));
        }
        return isWidgetMode;
    }

    static isMaintenanceMode(searchQ) {
        const searchQuery = searchQ || window.location.search;
        if (isMaintenanceMode === null || searchQuery) {
            isMaintenanceMode = Util.getBoolean(Util.getURLparameter('maintenance', searchQuery));
        }
        return isMaintenanceMode;
    }

    static determineMovementType(assetArray) {
        if (assetArray) {
            switch (typeof assetArray[0]) {
                case 'string':
                    return Util.MEDIA_TYPE.FOLDER;
                case 'object':
                    return Util.MEDIA_TYPE.ASSET;
                default:
                    return null;
            }
        }
        return null;
    }

    static rootedArrayPath(pathStrOrArray) {
        if (pathStrOrArray === null) {
            return null;
        }
        if (typeof pathStrOrArray === 'string') {
            if (/^_root_/.test(pathStrOrArray)) {
                return pathStrOrArray.split('>');
            }
            return [Util.ROOT_DIR].concat(pathStrOrArray.split('>')); // 'a>b' => [root,a,b]
        }
        return [Util.ROOT_DIR].concat(pathStrOrArray); // [a,b] => [root,a,b]
    }

    static async addDelay(ms_ = 10000) {
        let ms = ms_;
        if (typeof ms_ === 'string') {
            ms = parseInt(ms_, 10);
        }
        if (Number.isNaN(ms)) {
            ms = 10000;
        }
        return new Promise(resolve => {
            setTimeout(
                () => {
                    resolve(true);
                },
                Util.TESTING_MODE ? 0 : ms
            );
        });
    }

    static findLastNodeOnPaths(paths_, node) {
        // not the most efficient since we keep calling findNode.    Would be nice to combine
        // the two functions into one recursive function that we special-case for findNode but
        // that's for another day
        let lastFound = null;
        for (let j = 1; j <= paths_.length; j += 1) {
            const paths = paths_.slice(0, j);
            const found = Util.findNode(paths, node);
            if (found) {
                lastFound = {node: found, paths};
            } else {
                return lastFound;
            }
        }
        if (lastFound) {
            return lastFound;
        }
        return null;
    }

    // Recursively traverse tree node to find paths_'s tree node object
    // [_root_, 'path1', 'path2.1'] => {label: 'Level2.1', path: 'path2.1', ...}
    //
    static findNode(paths_, node) {
        const paths = paths_.slice(0);
        const currentPath = paths[0] ? paths[0].trim() : null;
        const currentLabel = node.label ? node.label.trim() : null;
        if (currentPath === node.path || currentPath === currentLabel) {
            if (paths.length === 1) {
                return node;
            }
            paths.shift();
            if (paths.length && node.children && node.children.length) {
                for (let i = 0; i < node.children.length; i += 1) {
                    const rval = Util.findNode(paths, node.children[i]);
                    if (rval) {
                        return rval;
                    }
                }
            }
        }
        return null;
    }

    // The key is used internally (good for select option values)
    // and the value is for the uri sort parameter needed by the backend
    //
    static internalSortValue2URIparam(internalValue) {
        const sortURIparam = {
            dateAsc: 'created,asc',
            dateDes: 'created,desc',
            heightAsc: 'height,asc',
            heightDes: 'height,desc',
            sizeAsc: 'fileSize,asc',
            sizeDes: 'fileSize,desc',
            nameAsc: 'label,asc',
            nameDes: 'label,desc',
            widthAsc: 'width,asc',
            widthDes: 'width,desc',
            type: 'mimeType,asc'
        };
        const sortBy = sortURIparam[internalValue];
        if (!sortBy) {
            if (process.env.NODE_ENV !== 'test') {
                console.error(`Unknown sort parameter: ${internalValue}`); // eslint-disable-line
            }
        }
        return sortBy;
    }

    // Given a filter, search query, and a internal sort value, return corresponding url parameters
    // for the back-end endpoints.
    // ('images', 'findme', 'nameAsc') => '&filterBy=image&q=findme&sort=label,asc'
    //
    static getExtraURLparams(filterSelect, searchQuery, internalSortBy) {
        let queryParam = '';
        if (filterSelect) {
            queryParam = {images: 'image', videos: 'video', documents: 'document'}[filterSelect];
            if (queryParam) {
                queryParam = `&filterBy=${queryParam}`;
            } else {
                queryParam = '';
            }
        }
        if (searchQuery && searchQuery.length) {
            if (!queryParam.length) {
                queryParam = `&q=${searchQuery}`;
            } else {
                queryParam = `${queryParam}&q=${searchQuery}`;
            }
        }
        if (internalSortBy && internalSortBy.length) {
            const sortBy = Util.internalSortValue2URIparam(internalSortBy);
            if (sortBy) {
                if (!queryParam.length) {
                    queryParam = `&sort=${sortBy}`;
                } else {
                    queryParam = `${queryParam}&sort=${sortBy}`;
                }
            }
        }
        return queryParam;
    }

    // Given an array of tree node paths, return a breadcrumb-like string of node labels
    // [_root_, 'path1', 'path2.1'] => '_root_ > Label1 > Label2.1'
    //
    static nodeLabel(paths_, node, labelPath_) {
        let labelPath = labelPath_;
        const paths = paths_.slice(0);
        const path = node.path || node.label;
        if (path === paths[0]) {
            paths.shift();
            labelPath = labelPath_ ? `${labelPath_} > ${node.label}` : node.label;
            if (paths.length && node.children && node.children.length) {
                for (let i = 0; i < node.children.length; i += 1) {
                    labelPath = Util.nodeLabel(paths, node.children[i], labelPath);
                }
            }
            return labelPath;
        }
        return labelPath;
    }

    static getDataSources(searchQuery) {
        const value = Util.getURLparameter('sources', searchQuery);
        if (value) {
            const parts = value.split(',').map(part => {
                let cleanPart = part.trim().toLowerCase();
                if (/^web/.test(cleanPart)) {
                    cleanPart = Util.SOURCE_TYPE.WEB;
                } else if (/^adv/.test(cleanPart)) {
                    cleanPart = Util.SOURCE_TYPE.ADV;
                } else {
                    cleanPart = Util.SOURCE_TYPE.WEB;
                }
                return cleanPart;
            });
            return parts;
        }
        return [Util.SOURCE_TYPE.WEB, Util.SOURCE_TYPE.ADV];
    }

    static getFilters(searchQuery) {
        const value = Util.getURLparameter('filters', searchQuery);
        if (value) {
            const parts = value.split(',').map(part => {
                let cleanPart = part.trim().toLowerCase();
                if (/^image/.test(cleanPart) || /^img/.test(cleanPart)) {
                    cleanPart = Util.ASSET_FILTER_TYPE.IMAGES;
                } else if (/^vid/.test(cleanPart)) {
                    cleanPart = Util.ASSET_FILTER_TYPE.VIDEOS;
                } else if (/^pdf/.test(cleanPart)) {
                    cleanPart = Util.ASSET_FILTER_TYPE.DOCUMENTS;
                } else {
                    cleanPart = Util.ASSET_FILTER_TYPE.IMAGES;
                }
                return cleanPart;
            });
            return parts;
        }
        return [Util.ASSET_FILTER_TYPE.IMAGES, Util.ASSET_FILTER_TYPE.VIDEOS, Util.ASSET_FILTER_TYPE.DOCUMENTS];
    }

    static async copyToClipboard(file, callback, isModal) {
        const value = file.url ? file.url : file.name;
        let isIOS = false;
        if (value) {
            const properValue = Util.getVideoAssetLink(value);
            if (navigator.clipboard) {
                navigator.clipboard.writeText(properValue);
            } else if (window.clipboardData) {
                window.clipboardData.setData('text', properValue);
            } else {
                const input = document.createElement('input');
                document.body.appendChild(input);
                this.iosCopyToClipboard(input, properValue);
                isIOS = true;
                document.body.removeChild(input);
            }
            Analytics.trackEvent(
                'Asset',
                `${isIOS ? 'Clipboard Copy IOS' : 'Clipboard Copy'}${isModal ? ' (Modal)' : ''}`
            );
        }

        if (callback) {
            // eslint-disable-next-line callback-return
            callback();
        }
    }

    static iosCopyToClipboard(element, value) {
        element.style = 'font-size: 100%; opacity: 0;';
        element.value = value;
        const oldContent = element.contentEditable;
        const oldReadOnly = element.readOnly;
        const range = document.createRange();

        element.contentEditable = true;
        element.readOnly = false;
        if (range.selectNodeContents) {
            range.selectNodeContents(element);

            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            element.setSelectionRange(0, 999999);
            element.contentEditable = oldContent;
            element.readOnly = oldReadOnly;

            document.execCommand('copy');
        }
    }

    // Only encode the string if it hasn't been encoded already
    static safeURIencode(_s) {
        let s = _s;
        try {
            s = decodeURIComponent(s);
        } catch (e) {} //eslint-disable-line
        return encodeURIComponent(s);
    }

    static isValidAssetId(assetId) {
        return typeof assetId !== 'undefined' && assetId !== null;
    }

    static suggestedFilename(filename, width = 0, height = 0, flipped = false) {
        if (!width || !height) {
            return filename || '';
        }
        const fileExtension = Util.getFileExtension(filename);
        const hasExtension = Boolean(fileExtension.length);
        const namePart = filename.slice(0, filename.length - fileExtension.length - (hasExtension ? 1 : 0));
        return `${namePart}-${Math.round(width)}x${Math.round(height)}${flipped ? '-flipped' : ''}${hasExtension ? '.' : ''}${fileExtension}`;
    }

    static convertPercentToPixel(width, height, percentX, percentY) {
        return {
            width: width * (percentX / 100),
            height: height * (percentY / 100)
        };
    }

    static decodeLabel(label, defaultLabelName = 'NOT_FOUND') {
        if (label) {
            // this is a horrible hack to handle UTF-8 filenmaes.  The database table (mesiaasset)
            // in nexus4 is not configured to handle non-ASCII characters so we store them
            // URL-encoded and decode them on the way out to the user.  Ugh.
            try {
                return decodeURIComponent(label);
            } catch (error) {
                // not a uri
                return label;
            }
        } else {
            if (defaultLabelName) {
                return Locale.getText(defaultLabelName);
            }
            return '';
        }
    }

    static isNonProd(url_) {
        const url = url_ || window.location.hostname;
        return ['localhost', '.local.', '.dev.', '.qa.', '-qa.', '.beta.', '-np.'].some(env => url.includes(env));
    }

    static setLocalStorage(key, data) {
        try {
            const {localStorage} = window;
            if (typeof data === 'object') {
                localStorage.setItem(key, JSON.stringify(data));
            } else {
                localStorage.setItem(key, data);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e.message ? e.message : 'Unable to set local storage.');
        }
    }

    static getLocalStorage(key, isJson = false) {
        let keyValue;
        try {
            const {localStorage} = window;
            keyValue = localStorage.getItem(key);
            if (isJson) {
                keyValue = JSON.parse(keyValue);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e.message ? e.message : 'Unable to get local storage.');
        }
        return keyValue;
    }

    static getCookie(name) {
        const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
        return match ? decodeURIComponent(match[1]) : null;
    }

    static buildUrlWithoutParameter(parameterKey, url_) {
        const url = url_ || window.location.href;
        const parmStart = url.indexOf('?');
        if (parmStart !== -1) {
            const searchQuery = url.substring(parmStart + 1);
            if (searchQuery.length) {
                const params = new URLSearchParams(searchQuery);
                if (params?.has(parameterKey)) {
                    const urlWithoutParms = url.substring(0, parmStart);
                    params.delete(parameterKey);
                    const newParamsStr = params.toString();
                    return newParamsStr.length ? `${urlWithoutParms}?${params.toString()}` : urlWithoutParms;
                }
            }
        }
        return url;
    }

    static async loggedOutCheck() {
        if (process.env.NODE_ENV !== 'test') {
            const jwt = Util.getURLparameter('__jwt_session');
            if (jwt) {
                return; // Processed elsewhere
            }

            const now = Date.now();
            const oldLastLogoutCheck = Util.lastLogoutCheck;
            if (Util.lastLogoutCheck + Util.MIN_LOGOUTCHECK_ELAPSE < now) {
                Util.lastLogoutCheck = now;
                localStorage.setItem('DPlastLogoutCheck', Util.lastLogoutCheck);
                console.log(`Login check at ${new Date(now)}`); // eslint-disable-line
                let isLoggedOut = false;
                try {
                    // Local dev serves this app from a different domain than the proxy target, so the browser
                    // won't auto-attach the JWTAuth cookie here; send it explicitly instead.
                    const isLocal = Util.isLocalDev();
                    const jwtAuth = isLocal ? Util.getCookie('JWTAuth') : null;
                    const response = await fetch('/landing/nxlambda/feeManager/version', {
                        headers: jwtAuth ? {Authorization: `Bearer ${jwtAuth}`} : undefined
                    }); // TODO: switch to controlcenter/version when its done
                    if (!response.ok) {
                        isLoggedOut = true;
                    }
                } catch (e) {
                    isLoggedOut = true;
                }
                console.log(`We are logged out: ${isLoggedOut}`); // eslint-disable-line
                if (isLoggedOut && !Util.isWidget()) {
                    setTimeout(() => {
                        const host = Util.isLocalDev()
                            ? `${window.location.protocol}//apps.dealercenter-np.coxautoinc.com/`
                            : `${window.location.protocol}//${window.location.hostname}`;
                        const extra = window.location.href.includes('?') ? '&' : '?';
                        const goTo = `${host}/session/JwtSession?callback=${encodeURIComponent(
                            `${window.location.href}${extra}`
                        )}__jwt_session=%7Bauth_jwt%7D&idp=`;
                        if (!Util.isLocalDev()) {
                            window.location.href = goTo;
                        }
                        console.log(`Logged out, going to: ${goTo}`); // eslint-disable-line
                    }, 2000);
                }
            } else {
                /* eslint-disable-next-line */
                console.log(`Too soon to check for logout (${(now - oldLastLogoutCheck) / 1000}s)`); // eslint-disable-line
            }
        }
    }

    static createUID() {
        return ulid();
    }

    static dataURLtoFile(dataurl, filename) {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[arr.length - 1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        // eslint-disable-next-line no-plusplus
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type: mime});
    }

    static setUploaderLibraryId(path) {
        uploaderLibraryId = path;
    }

    static getUploaderLibraryId() {
        return uploaderLibraryId;
    }

    static deepCopyObject(obj) {
        let newObj;
        if (obj === null || obj === undefined) {
            return obj;
        }
        if (obj instanceof Map) {
            newObj = new Map();
            obj.forEach((value, key) => {
                newObj.set(key, Util.deepCopyObject(value));
            });
        } else if ('length' in obj) {
            newObj = [...obj];
            newObj.forEach((child, idx) => {
                if (typeof child === 'object') {
                    newObj[idx] = Util.deepCopyObject(child);
                }
            });
        } else {
            newObj = {...obj};
            const keys = Object.keys(newObj);
            keys.forEach((key, idx) => {
                if (typeof newObj[keys[idx]] === 'object') {
                    newObj[keys[idx]] = Util.deepCopyObject(newObj[keys[idx]]);
                }
            });
        }
        return newObj;
    }
}
